import React from 'react';
import theme from '@/style';
import {toPriceStr} from '@/utils';
import {useTranslation} from 'react-i18next';

type DomStyle = React.CSSProperties | React.CSSProperties[];

const flattenStyle = (style?: DomStyle): React.CSSProperties =>
  Array.isArray(style) ? Object.assign({}, ...style) : style || {};

const WonResult = ({
  awardAmount,
  style,
}: {
  awardAmount?: number;
  style?: DomStyle;
}) => {
  const {i18n} = useTranslation();
  const ribbonColor = theme.basicColor.darkPrimary;

  return (
    <div className="relative mt-3 px-5 pb-1" style={flattenStyle(style)}>
      <svg
        width="44"
        height="36"
        viewBox="0 0 45 36"
        className="absolute bottom-0 left-0">
        <path
          d="M44.5 0H0.499996L10.9762 18L0.499996 36H44.5V0Z"
          fill={ribbonColor}
        />
      </svg>
      <svg
        width="44"
        height="36"
        viewBox="0 0 45 36"
        className="absolute bottom-0 right-0">
        <path d="M0.5 0H44.5L34.0238 18L44.5 36H0.5V0Z" fill={ribbonColor} />
      </svg>
      <div
        className="relative z-[1] flex flex-col items-center px-2 py-1"
        style={{backgroundColor: theme.basicColor.primary}}>
        <span className="text-sm text-white">
          {i18n.t('game-page.label.guessRight')}
        </span>
        <div className="flex items-center">
          <span className="text-sm text-white">
            {i18n.t('game-page.label.total')}{' '}
          </span>
          <span className="font-InterBold text-lg text-white">
            {toPriceStr(awardAmount)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default WonResult;
